export enum RouteEnum {
  WELCOME = '/',
  MY_DATA = '/meus-dados',
  TALK_TO_US = '/fale-conosco',
  /** Simulador de pontos (público) */
  SIMULATOR = '/simulador',
  HOW_TO_JOIN_POINTS = '/como-juntar-pontos',
  HOW_TO_JOIN_POINTS_DETAIL = '/como-juntar-pontos/:id',

  // AUTH = '/authentication',
  // LOGIN_OTP = '/login-otp',
  HOME = '/home',
  WELCOME_CONTENT = '/welcomeContent',
  LOGIN_USERNAME = '/login-username',
  LOGIN_PASSWORD = '/login-password',
  LOGOUT = '/logout',
  CALLBACK = '/callback',

  // password
  CREATE_PASSWORD = '/create-password',
  FORGOT_PASSWORD_OTP_REQUEST = '/request/otp/forgot-password',
  RESET_PASSWORD = '/reset-password',
  VALIDATE_OTP_RESET_PASSWORD = '/validation/otp/reset-password',

  // Signup & Personal Info
  CREATE_PASSWORD_ONBOARDING = '/onboarding/password/register',
  PERSONAL = '/personal',
  CONTACT = '/contact',
  ADDRESS = '/address',

  // Validation
  OTP_REQUEST = '/request/otp',
  OTP_VALIDATION = '/validation/otp',
  SIGNUP_VALIDATION = '/validation/signup',
  SIGNUP_VALIDATION_CODE = '/code/signup',
  PASSWORD_VALIDATION = '/validation/password',
  PASSWORD_VALIDATION_CODE = '/code/password',

  // Miscellaneous
  INVITATION = '/invitation',
  INVITATION_CHOICE = '/invitation-choice',
  ADD_INFO = '/info',
  FINISH = '/finish',
  OTP = '/otp',
  COMPLEMENTARY_STEP = '/complementary-step',
}

export const buildHowToJoinPointsDetailRoute = (
  id: string | number
): string => RouteEnum.HOW_TO_JOIN_POINTS_DETAIL.replace(':id', String(id));
